var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1989 1.64074C12.2214 1.08892 11.7923 0.623322 11.2405 0.600807L2.24796 0.233906C1.69613 0.211391 1.23054 0.640482 1.20802 1.19231C1.18551 1.74413 1.6146 2.20973 2.16642 2.23224L10.1598 2.55838L9.83364 10.5517C9.81112 11.1036 10.2402 11.5691 10.792 11.5917C11.3439 11.6142 11.8095 11.1851 11.832 10.6333L12.1989 1.64074ZM1.67769 11.7353L11.8774 2.33532L10.522 0.86463L0.322308 10.2647L1.67769 11.7353Z",
    fill: "#0B1957"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBlack);
export default __webpack_public_path__ + "static/media/arrow-black.345cada6440de9e0aa59d66d5636ca7c.svg";
export { ForwardRef as ReactComponent };